import React, { useContext } from 'react';
import Home from '../components/Home/Home';
import Onboarding from '../components/Onboarding/Onboarding'
import { Switch, Route, BrowserRouter, useLocation } from "react-router-dom";
import FAQ from '../components/FAQs/FAQs'
import ApiDocumentation from '../components/ApiDocumentation/ApiDocumentation';

import '../styles/styles.css'
import PrivateRoute from './PrivateRoute';
import { authContext } from '../provider/Context/AuthContext';
import { useFlags } from 'launchdarkly-react-client-sdk';


const Routes: React.FC = (props) => {

        const { showApiMaticDocument } = useFlags();
        const baseName = "/ui";
        const auth = useContext(authContext);

        return (
                <Switch>
                        <PrivateRoute path={`${baseName}/onboarding`} roles={null} component={Onboarding} />
                        <Route path={`${baseName}/faq`} component={FAQ}></Route>
                        {showApiMaticDocument &&
                                <Route path={`${baseName}/documentation`} component={ApiDocumentation}></Route>
                        }
                        <Route path="/" component={Home}></Route>
                </Switch>
        );
}

export default Routes;